import { makeVar } from '@apollo/client'
import { RadioType } from './AddProductTypes'

export interface AddProductDialogState {
    categories: string[]
    errors: Record<string, string>
    familyRadio: RadioType
    firmId: string
    firmName: string
    model: string
    productName: string
    productType: string
    productTypeRadio: RadioType
    sectionNames: string
    sectionNumber: string
    sectionTitle: string
    type: string
    isProductNameVerified: boolean
}

export const defaultAddProductDialogState = {
    categories: [],
    errors: {},
    familyRadio: RadioType.Existing,
    firmName: '',
    model: '',
    productName: '',
    productType: '',
    productTypeRadio: RadioType.Existing,
    sectionNames: '',
    sectionNumber: '',
    sectionTitle: '',
    type: '',
    firmId: '',
    isProductNameVerified: false,
}

export const addProductDialogState = makeVar<AddProductDialogState>({
    ...defaultAddProductDialogState,
})

export const setProductDialogState = (
    newState: Partial<AddProductDialogState>
) => {
    const prevState = addProductDialogState()
    addProductDialogState({ ...prevState, ...newState })
}

export const categoriesOptionsState = makeVar<string[]>([])
export const setCategoriesOptionsState = (categories: string[]) =>
    categoriesOptionsState(categories)
